import {createGlobalStyle} from "styled-components";
import Crimson from "../../assets/webfonts/Crimson_Text/CrimsonText-Regular.ttf";
import CrimsonSemiBold from "../../assets/webfonts/Crimson_Text/CrimsonText-SemiBold.ttf";
import CrimsonBold from "../../assets/webfonts/Crimson_Text/CrimsonText-Bold.ttf";
import Nunito from "../../assets/webfonts/Nunito/Nunito-Regular.ttf";
import NunitoSemiBold from "../../assets/webfonts/Nunito/Nunito-SemiBold.ttf";
import NunitoBlack from "../../assets/webfonts/Nunito/Nunito-Black.ttf";
import NunitoBold from "../../assets/webfonts/Nunito/Nunito-Bold.ttf";
import OpenSans from "../../assets/webfonts/Open_Sans/OpenSans-Regular.ttf";
import OpenSansSemiBold from "../../assets/webfonts/Open_Sans/OpenSans-SemiBold.ttf";
import OpenSansBold from "../../assets/webfonts/Open_Sans/OpenSans-Bold.ttf";
import Raleway from "../../assets/webfonts/Raleway/Raleway-Regular.ttf";
import RalewayMedium from "../../assets/webfonts/Raleway/Raleway-Medium.ttf";
import RalewayBold from "../../assets/webfonts/Raleway/Raleway-Bold.ttf";
import FiraSans from "../../assets/webfonts/Fira_Sans/FiraSans-Regular.ttf";
import FiraSansMedium from "../../assets/webfonts/Fira_Sans/FiraSans-Medium.ttf";
import FiraSansBold from "../../assets/webfonts/Fira_Sans/FiraSans-Bold.ttf";

import Rubik from "../../assets/webfonts/Rubik/Rubik-Regular.ttf";
import Ubuntu from "../../assets/webfonts/Ubuntu/Ubuntu-Regular.ttf";

import breakpoint from "styled-components-breakpoint";
import backgroundLetters from '../../assets/images/background-letters.png';

const GlobalStyle = createGlobalStyle`
  html {
  };
  body {
    font-family: ${props => props.theme.fontFamily};
    font-size: ${props => props.theme.fontSize};
    color: ${props => props.theme.primaryColor}
    overflow-x: hidden;
    margin-top: 0;
    background-image: url(${backgroundLetters});
    
    ${breakpoint('xs', 's')`
        line-height: 1.25em;
    `};
    
    ${breakpoint('lg')`
        font-size: 1.3rem;
    `};
  };
    @font-face {
    font-family: Crimson;
    src: url('${Crimson}') format('truetype');
  }
    @font-face {
    font-family: CrimsonMedium;
    src: url('${CrimsonSemiBold}') format('truetype');
  }
    @font-face {
    font-family: CrimsonBold;
    src: url('${CrimsonBold}') format('truetype');
  }
  @font-face {
    font-family: Nunito;
    src: url('${Nunito}') format('truetype');
  }
  @font-face {
    font-family: NunitoSemiBold;
    src: url('${NunitoSemiBold}') format('truetype');
  }
  @font-face {
    font-family: NunitoBlack;
    src: url('${NunitoBlack}') format('truetype');
  }
  @font-face {
    font-family: NunitoBold;
    src: url('${NunitoBold}') format('truetype');
  }
  @font-face {
    font-family: OpenSans;
    src: url('${OpenSans}') format('truetype');
  }
  @font-face {
    font-family: OpenSansMedium;
    src: url('${OpenSansSemiBold}') format('truetype');
  }
  @font-face {
    font-family: OpenSansBold;
    src: url('${OpenSansBold}') format('truetype');
  }
  @font-face {
    font-family: Raleway;
    src: url('${Raleway}') format('truetype');
  }
  @font-face {
    font-family: RalewayMedium;
    src: url('${RalewayMedium}') format('truetype');
  }
  @font-face {
    font-family: RalewayBold;
    src: url('${RalewayBold}') format('truetype');
  }
  @font-face {
    font-family: FiraSans;
    src: url('${FiraSans}') format('truetype');
  }
  @font-face {
    font-family: FiraSansMedium;
    src: url('${FiraSansMedium}') format('truetype');
  }
  @font-face {
    font-family: FiraSansBold;
    src: url('${FiraSansBold}') format('truetype');
  }
  @font-face {
    font-family: Rubik;
    src: url('${Rubik}') format('truetype');
  }
  @font-face {
    font-family: Ubuntu;
    src: url('${Ubuntu}') format('truetype');
  }
`;


export {GlobalStyle};
